import React, { memo } from 'react'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useCta6 } from './Cta6.hooks'
import Content from './components/Content'

const Cta6 = props => {
	const [
		{
			classes,
			withImage,
			image,
			mobileAlignment,
			mobileButtonWidth,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonTextConfig,
			buttonLink,
			buttonAction,
			buttonTextEditable,
			buttonTextKey,
		},
		{ handleImageClick, handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange },
	] = useCta6(props)

	return (
		<Content
			classes={classes}
			mobileAlignment={mobileAlignment}
			mobileButtonWidth={mobileButtonWidth}
			withImage={withImage}
			image={image}
			text={text}
			textConfig={textConfig}
			buttonText={buttonText}
			onButtonTextChange={handleButtonTextChange}
			buttonTextConfig={buttonTextConfig}
			buttonTextEditable={buttonTextEditable}
			buttonLink={buttonLink}
			buttonAction={buttonAction}
			onImageClick={handleImageClick}
			onTextClick={handleTextClick}
			onButtonClick={handleButtonClick}
			textEditable={textEditable}
			onTextChange={handleTextChange}
			textKey={textKey}
			buttonTextKey={buttonTextKey}
		/>
	)
}

Cta6.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Cta6)
